<div class="body">
  <div class="container ">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Administración de <span class="txtbienvenida-2">nivel ventas</span></h3>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-sm-12 mt-3">
        <p class="title-box">*Desde aqui puedes administrar el nivel de ventas</p>
      </div>
    </div>
    <div class="row justify-content-center">
      <form [formGroup]="adminVentasForm" class="custom-form row col-md-10 mx-auto" (ngSubmit)="validateForm()">
        <div class="col-12 col-sm-4 mt-4">
          <div class="mb-3 required form-label" [ngClass]="{err: isValidForm('nivelVentasInicial')}">
            <label for="nivelInicial" class="form-label">Nivel inicial rango</label>
            <input type="text" maxlength="19" class="form-control"
              formControlName="nivelVentasInicial" placeholder="COP"
              [ngClass]="{'is-invalid':isValidForm('nivelVentasInicial')}" required>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-4 mt-4">
            <div class="mb-3 required form-label" [ngClass]="{err: isValidForm('nivelVentasFinal')}">
              <label for="nivelFinal" class="form-label">Nivel final rango</label>
              <input type="text" maxlength="19" class="form-control"
                formControlName="nivelVentasFinal" placeholder="COP"
                [ngClass]="{'is-invalid':isValidForm('nivelVentasFinal')}" required>
                <div class="invalid-feedback">
                  Campo obligatorio
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-4 d-flex justify-content-center align-items-center">
              <button type="submit" id="btn-agregar" class="btn btn-primary hvr-shrink">Agregar rango</button>
            </div>
          </form>
        </div>

        @if (listaNeoNivelVentasIntermediarioDTO.length>0) {
          <div class="row mt-4 pr-3 pl-3">
            <div class="table-responsive">
              <table class="table table-striped table-borderless rounded">
                <thead class="table_head">
                  <tr>
                    <th scope="col" class="no-styles table-header" id="date-rango">Fecha de creación del rango
                    </th>
                    <th scope="col" class="no-styles table-header" id="date-rec">Nivel inicial del rango</th>
                    <th scope="col" class="no-styles table-header" id="solicitante">Nivel final del rango</th>
                    <th scope="col" class="no-styles table-header" id="doc">Modificar/Eliminar</th>
                  </tr>
                </thead>
                <tbody>
                  @for (nivel of listaNeoNivelVentasIntermediarioDTO; track nivel; let i = $index) {
                    <tr>
                      <th scope="row" id="id-monto">{{nivel.fechaCreacion | date: 'dd/MM/yyyy' : 'UTC'}}
                      </th>
                      <td>{{nivel.nivelVentasInicial <999 ? "$ " +nivel.nivelVentasInicial :
                      nivel.nivelVentasInicial | currency: 'USD' }} </td>
                      <td>{{nivel.nivelVentasFinal | currency:'USD'}}</td>
                      <td><button id="btn-editar" type="button" class="hvr-shrink" data-bs-toggle="modal"
                        data-bs-target="#editModal" (click)="editarFilaNivelVentas(i)"><i
                      class="fas fa-pencil-alt"></i></button>
                      <button id="btn-borrar" type="button" class="hvr-shrink"
                        (click)="borrarFilaNivelVenta(i)">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <app-pagination (event)="selectPage($event)" [paginaActual]="paginaActual"
            [totalPaginas]="totalPaginas"></app-pagination>
          </div>
        </div>
      }
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-4 container-btn">
          <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="goHome()">Volver</button>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModalLabel">EDITAR RANGO DE VENTA</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

            </button>
          </div>
          <div class="modal-body-monto m-3">
            <form class="custom-form" [formGroup]="editarVentasForm">
              <div class="box-montos">
                <div class="mb-3 required text-start"
                  [ngClass]="{err: isValidFormEditar( 'nivelVentasInicial')} ">
                  <label for="nivelIncial" class="form-label">Nivel inicial rango</label>
                  <input class="form-control box-number" maxlength="19 " type="text "
                    formControlName="nivelVentasInicial"
                    [ngClass]="{ 'is-invalid':isValidFormEditar( 'nivelVentasInicial')} " required>
                    <div class="invalid-feedback">
                      Campo obligatorio
                    </div>
                  </div>
                </div>
                <div class="box-montos">
                  <div class="mb-3 required text-start"
                    [ngClass]="{err: isValidFormEditar( 'nivelVentasFinal')} ">
                    <label for="nivelVentasFinal" class="form-label">Nivel final rango</label>
                    <input class="form-control box-number" maxlength="19" type="text"
                      formControlName="nivelVentasFinal"
                      [ngClass]="{ 'is-invalid':isValidFormEditar( 'nivelVentasFinal')} " required>
                      <div class="invalid-feedback">
                        Campo obligatorio
                      </div>
                    </div>
                  </div>
                  <div class="box-montos">
                    <div class="mb-3 required text-start"
                      [ngClass]="{err: isValidFormEditar( 'justificacion')} ">
                      <p>Justificación</p>
                      <textarea maxlength="200" style="width: 100%;" rows="3 " type="text"
                        formControlName="justificacion" class="form-control"
                        [ngClass]="{ 'is-invalid':isValidFormEditar( 'justificacion')} "
                      required></textarea>
                      <div class="invalid-feedback" style="color: red !important">
                        Campo obligatorio
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" [disabled]="editarVentasForm.invalid"
                (click)="editarNivelVentas()">Modificar</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">BORRAR NIVEL VENTA</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                </button>
              </div>
              <div class="modal-body-monto m-3">
                <div class="box-montos">
                  <div class="mb-3 required text-start">
                    <label for="inicial" class="form-label">Nivel inicial rango</label>
                    <strong>{{eliminarNivelVentaIntermediarioDTO.nivelVentasInicial | currency:'USD'}}</strong>
                  </div>
                </div>
                <div class="box-montos">
                  <div class="mb-3 required text-start">
                    <label for="final" class="form-label">Nivel final rango</label>
                    <strong>{{eliminarNivelVentaIntermediarioDTO.nivelVentasFinal | currency:'USD'}}</strong>
                  </div>
                </div>
                <div class="box-montos">
                  <div class="mb-3 required text-start">
                    <label for="justificacion" class="form-label">Justificacion</label>
                    <textarea maxlength="200" style="width: 100%;"
                      rows="3" type="text" required
                      name="justificacionDelete"
                      [(ngModel)]="eliminarNivelVentaIntermediarioDTO.justificacion"
                    class="form-control"></textarea>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" (click)="borrarVenta()">Borrar</button>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-body"></div>
      </div>
      <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
